import { AxiosResponse } from 'axios';
import { get, post } from './apiUtil';
import { QuarantineEventValidationResponse } from '../model/quarantineEventValidationResponse';

export function validateQuarantineEvent(queryString: string): Promise<QuarantineEventValidationResponse> {
  return new Promise((resolve, reject) => {
    get(`/api/eaus/v1/quarantine/validateQuarantineEvent` + queryString)
      .then((response: AxiosResponse) => resolve(response.data as QuarantineEventValidationResponse))
      .catch((e) => reject(e));
  });
}

export function transferQuarantineEvent(eventId: string, newEventId: string): Promise<AxiosResponse> {
  return new Promise((resolve, reject) => {
    post(`/api/eaus/v1/quarantine/process/${eventId}/to/${newEventId}`, {})
      .then((response: AxiosResponse) => resolve(response.data))
      .catch((e) => reject(e));
  });
}

export function resolveQuarantineEvent(eventId: string): Promise<AxiosResponse> {
  return new Promise((resolve, reject) => {
    post(`/api/eaus/v1/quarantine/${eventId}/markResolved`, {})
      .then((response: AxiosResponse) => resolve(response.data))
      .catch((e) => reject(e));
  });
}
